<template>
  <div class="visit-aaci-summary">
    <VitalSignsSummary :readings="visit.vitalSigns || []" />
    <div v-if="visit.ackDt" class="description text-muted">
      แพทย์รับทราบก่อนรักษา {{ ackName }} {{ time(visit.ackDt) }}
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VitalSignsSummary from "@/components/aaci/VitalSignsSummary";

export default {
  name: "VisitAaciSummary",
  components: { VitalSignsSummary },
  props: {
    visit: { type: Object, required: true },
  },
  computed: {
    ackName() {
      const u = this.visit.ackU;
      return u ? `${u.firstNameTh} ${u.lastNameTh}` : "";
    },
  },
  methods: {
    time(dt) {
      return dt ? moment(dt).format("HH:mm") : "";
    },
  },
};
</script>
